import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CookieHandler from '../pages/LandingPage/Authentication/CookieHandler.js';

const DownloadFileRequest = async (path, isAuthenticated, filename) => {
  let headers = {
    'Content-Type': 'application/json'
  };

  const apiUrl = process.env.REACT_APP_API_URL;
  console.log('API URL:', apiUrl);

  if (isAuthenticated) {
    const token = CookieHandler.getCookie('token');
    headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await axios.get(apiUrl + `/api/${path}`, {
      headers,
      responseType: 'blob' // Important for handling binary data
    });

    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename); // Use filename from parameter
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // Display a toast for non-200 response
      toast.error('Server returned an error. Please try again later.');
    }
  } catch (error) {
    // Handle any errors that occur during the request
    console.error('Error in downloadFile:', error);
    toast.error('A network or Server error occurred. Please try again later.');
  }
};

export default DownloadFileRequest;
